export const formatDateForAPI = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatCurrency = (amount) => {
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount || 0);
  } catch (e) {
    return `₹${amount || 0}`;
  }
};

export const formatDate = (dateString) => {
  try {
    return new Date(dateString).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch (e) {
    return "—";
  }
};

export const formatTime = (iso) => {
  try {
    if (!iso) return "";
    return new Date(iso).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Asia/Kolkata",
    });
  } catch (e) {
    return "";
  }
};

export const formatSlotRange = (slot) => {
  if (!slot?.startTime || !slot?.endTime) return null;
  const start = formatTime(slot.startTime);
  const end = formatTime(slot.endTime);
  return `${start} - ${end}`;
};

export const formatTime12 = (time24) => {
  if (!time24) return "";
  const [hhStr, mmStr = "00"] = String(time24).split(":");
  const hh = Number(hhStr);
  const mm = Number(mmStr);

  if (!Number.isFinite(hh) || !Number.isFinite(mm)) return String(time24);

  const period = hh >= 12 ? "PM" : "AM";
  let h12 = hh % 12;
  if (h12 === 0) h12 = 12;

  const mm2 = String(mm).padStart(2, "0");
  return `${h12}:${mm2} ${period}`;
};

export const formatCenterSlotRange = (slot) => {
  if (!slot?.startTime || !slot?.endTime) return null;
  const start = formatTime12(slot.startTime);
  const end = formatTime12(slot.endTime);
  return `${start} - ${end}`;
};



export const getStatusBadge = (status) => {
  switch (status?.toLowerCase()) {
    case "completed":
      return "bg-emerald-50 text-emerald-700 border border-emerald-200";
    case "confirmed":
      return "bg-sky-50 text-sky-700 border border-sky-200";
    case "pending":
      return "bg-amber-50 text-amber-700 border border-amber-200";
    case "cancelled":
      return "bg-rose-50 text-rose-700 border border-rose-200";
    case "sample_collected":
      return "bg-violet-50 text-violet-700 border border-violet-200";
    default:
      return "bg-gray-50 text-gray-700 border border-gray-200";
  }
};

export const getPaymentStatusBadge = (status) => {
  const statusLower = status?.toLowerCase();
  switch (statusLower) {
    case "paid":
    case "captured":
    case "completed":
      return "bg-emerald-50 text-emerald-700";
    case "pending":
    case "authorized":
    case "failed":
      return "bg-amber-50 text-amber-700";
    case "refunded":
      return "bg-blue-50 text-blue-700";
    default:
      return "bg-gray-50 text-gray-700";
  }
};